import * as actionTypes from '../actionTypes'

const thisUrl = window.location.hostname

const login = (state = {
	environment: (process.env.NODE_ENV === 'production') ? (thisUrl.toLowerCase().includes('test') ? 'test' : '') : 'development',
	isLoading: false,
	isLoggedIn: false,
	accessToken: null,
	username: null,
	error: null,
	roles: []
}, action) => {
	
	switch (action.type) {
		case actionTypes.LOGIN_STARTED:
			return {
				...state,
				isLoading: true,
				isLoggedIn: false,
				username: action.username,
				error: null
			}
		case actionTypes.LOGIN_COMPLETED:
			return {
				...state,
				isLoading: false,
				accessToken: action.accessToken,
				username: action.username || state.username,
				isLoggedIn: true,
				error: null,
				roles: action.roles || state.roles
			}
		case actionTypes.LOGIN_FAILED:
			return {
				...state,
				isLoading: false,
				isLoggedIn: false,
				error: action.error
			}
		case actionTypes.LOGIN_LOGOUT:
			return {
				...state,
				isLoading: false,
				isLoggedIn: false,
				error: null
			}
		default:
			return state
	}
}

export default login


// WEBPACK FOOTER //
// ./src/reducers/login.js